export default __webpack_public_path__ + "static/media/brail.89cc2ef8.webp";